var _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIcHourglass({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12.75 14.25H11.25V15.75H12.75V14.25Z",
    fill: "#030712"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M12.75 17.25H11.25V18.75H12.75V17.25Z",
    fill: "#030712"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M17.25 8.7525V3H19.5V1.5H4.5V3H6.75V8.7525C6.75 9.07706 6.85527 9.39286 7.05 9.6525L8.8125 12L7.05 14.3475C6.85527 14.6071 6.75 14.9229 6.75 15.2475V21H4.5V22.5H19.5V21H17.25V15.2475C17.25 14.9229 17.1447 14.6071 16.95 14.3475L15.1875 12L16.95 9.6525C17.1447 9.39286 17.25 9.07706 17.25 8.7525ZM15.75 3V8.25H8.25V3H15.75ZM15.75 15.2475V21H8.25V15.2475L10.6875 12L9 9.75H15L13.3125 12L15.75 15.2475Z",
    fill: "#030712"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcHourglass);
export default __webpack_public_path__ + "static/media/ic-hourglass.1968465f99866da6f58e1f58b4202bec.svg";
export { ForwardRef as ReactComponent };